export default __webpack_public_path__ + "static/media/rocket_anim_162.13e3cca6.png";